// import { useState } from "react";
import { Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/my-health-my-way.png";

import DashboardIcon from "../../assets/images/side-nav-icons/dashboard-manager.svg";
import ActivesessionIcon from "../../assets/images/side-nav-icons/Active-Session-manager.svg";
import UsermanagerIcon from "../../assets/images/side-nav-icons/User-Manager.svg";
import CategoryIcons from "../../assets/images/side-nav-icons/Document-Category-Manager.svg";
import ReportManagerIcon from "../../assets/images/side-nav-icons/report-manager.svg";
import UserJourneyIcon from "../../assets/images/side-nav-icons/User-Journey.svg"
import SubscriptioIcon from "../../assets/images/side-nav-icons/subscription-manager.svg";
import TransactionIcon from "../../assets/images/side-nav-icons/transaction-pamanger.svg";
import EmailTemplateIcon from "../../assets/images/side-nav-icons/emai-mnager.svg";
import LabManagementIcon from "../../assets/images/side-nav-icons/content-manager.svg";
import ContentIcon from "../../assets/images/side-nav-icons/lab-manager.svg";
import CouponIcon from "../../assets/images/side-nav-icons/coupon-manager.svg";
import DoctorIcon from "../../assets/images/side-nav-icons/doctor.svg";

import lang from "../../helper/lang";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const menuItems = [
    {
      key: "dashboard",
      label: (
        <NavLink to="/dashboard">
          <span
            className="icon"
            style={{ background: page === "dashboard" ? color : "" }}
          >
            <img src={DashboardIcon} alt="" />
          </span>
          <span className="label">{lang("Dashboard")}</span>
        </NavLink>
      ),
    },
    {
      key: "session",
      label: (
        <NavLink to="/active-session">
          <span
            className="icon"
            style={{ background: page === "session" ? color : "" }}
          >
            <img src={ActivesessionIcon} alt="" />
          </span>
          <span className="label">{lang("Active Session")}</span>
        </NavLink>
      ),
    },
    {
      key: "user-manager",
      label: (
        <NavLink to="/user-manager">
          <span
            className="icon"
            style={{ background: page === "user-manager" ? color : "" }}
          >
            <img src={UsermanagerIcon} alt="" />
          </span>
          <span className="label">User Manager</span>
        </NavLink>
      ),
    },
    {
      key: "document-category-manager",
      label: (
        <NavLink to="/document-category-manager">
          <span
            className="icon"
            style={{
              background: page === "document-category-manager" ? color : "",
            }}
          >
            <img src={CategoryIcons} alt="" />
          </span>
          <span className="label">Document Category Manager</span>
        </NavLink>
      ),
    },
    {
      key: "report-manager",
      label: (
        <NavLink to="/report-manager">
          <span
            className="icon"
            style={{
              background: page === "report-manager" ? color : "",
            }}
          >
            <img src={ReportManagerIcon} alt="" />
          </span>
          <span className="label">Manage Reports</span>
        </NavLink>
      ),
    },
    {
      key: "user-journey",
      label: (
        <NavLink to="/user-journey">
          <span
            className="icon"
            style={{
              background: page === "user-journey" ? color : "",
            }}
          >
            <img src={UserJourneyIcon} alt="" />
          </span>
          <span className="label">User Journey</span>
        </NavLink>
      ),
    },
    {
      key: "subscription-price-manager",
      label: (
        <NavLink to="/subscription-price-manager">
          <span
            className="icon"
            style={{
              background: page === "subscription-price-manager" ? color : "",
            }}
          >
            <img src={SubscriptioIcon} alt="" />
          </span>
          <span className="label">Subscription Price Manager</span>
        </NavLink>
      ),
    },
    {
      key: "coupon-manager",
      label: (
        <NavLink to="/coupon-manager">
          <span
            className="icon"
            style={{
              background: page === "coupon-manager" ? color : "",
            }}
          >
            <img src={CouponIcon} alt="" />
          </span>
          <span className="label">Coupon Manager</span>
        </NavLink>
      ),
    },
    {
      key: "transaction-manager",
      label: (
        <NavLink to="/transaction-manager">
          <span
            className="icon"
            style={{
              background: page === "transaction-manager" ? color : "",
            }}
          >
            <img src={TransactionIcon} alt="" />
          </span>
          <span className="label">Subscription Transactions</span>
        </NavLink>
      ),
    },
    {
      key: "email-template-manager",
      label: (
        <NavLink to="/email-template-manager">
          <span
            className="icon"
            style={{
              background: page === "email-template-manager" ? color : "",
            }}
          >
            <img src={EmailTemplateIcon} alt="" />
          </span>
          <span className="label">Email Templates</span>
        </NavLink>
      ),
    },
    {
      key: "lab-manager",
      label: (
        <NavLink to="/lab-manager">
          <span
            className="icon"
            style={{
              background: page === "lab-manager" ? color : "",
            }}
          >
            <img src={LabManagementIcon} alt="" />
          </span>
          <span className="label">Manage Labs</span>
        </NavLink>
      ),
    },
    {
      key: "doctor-manager",
      label: (
        <NavLink to="/doctor-manager">
          <span
            className="icon"
            style={{
              background: page === "doctor-manager" ? color : "",
            }}
          >
            <img src={DoctorIcon} alt="" />
          </span>
          <span className="label">Doctors</span>
        </NavLink>
      ),
    },
    {
      key: "content-manager",
      label: (
        <NavLink to="/content-manager">
          <span
            className="icon"
            style={{
              background: page === "content-manager" ? color : "",
            }}
          >
            <img src={ContentIcon} alt="" />
          </span>
          <span className="label">Content Manager</span>
        </NavLink>
      ),
    },
  ];  return (
    <>
      <div className="brand">
        <Link to="/dashboard" className="main-logo">
          <img src={logo} alt="" />
        </Link>
      </div>
      <hr />
      <Menu theme="light" mode="inline" items={menuItems} />
    </>
  );
}

export default Sidenav;
